import { MenuOutlined } from "@ant-design/icons";
import { Button, Dropdown, Menu } from "antd";
import React, { useState,useEffect, useRef } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { NavLink } from "react-router-dom";
import getPermissions from "../../utils/getPermissions";
import getRoleFromToken from "../../utils/getRoleFromToken";
import SidebarComponent from "../layouts/SidebarComponent";

// TODO: hasPermission(*) mostly not changed due to permission issues from backend

const Headnav = ({ mobile }) => {
  const permissions = getPermissions();

  const hasPermission = (item) => {
    return permissions?.includes(item ? item : "");
  };

  const menu = [
    (hasPermission("readAll-contactSource") ||
      hasPermission("readAll-crmTaskStatus") ||
      hasPermission("readAll-opportunitySource")) && {
      label: (
        <NavLink to='/admin/setup'>
          {/* <span>Dashboard</span> */}
        </NavLink>
      ),
      key: "setup",
    },
    // (hasPermission("readAll-quote") ||
    //   hasPermission("readSingle-quote") ||
    //   hasPermission("create-quote")) && {
    //   label: (
    //     <NavLink to='/admin/booking'>
    //       <span>Quote</span>
    //     </NavLink>
    //   ),
    //   key: "quote",
    // },
    // permissions && {
    //   label: (
    //     <NavLink
    //       to={
    //         getRoleFromToken() !== "customer"
    //           ? "/admin/dashboard"
    //           : "/customer/dashboard"
    //       }
    //     >
    //       <span>Dashboard</span>
    //     </NavLink>
    //   ),
    //   key: "dashboard",
    // },
    // (hasPermission("readAll-contact") ||
    //   hasPermission("readSingle-contact") ||
    //   hasPermission("create-contact")) && {
    //   label: (
    //     <NavLink to='/admin/contact'>
    //       <span className='py-4'>Contact</span>
    //     </NavLink>
    //   ),
    //   key: "contact",
    // },
    // (hasPermission("readAll-user")) && {
    //   label: (
    //     <NavLink to='/admin/setup/staffs'>
    //       <span>All Franchise</span>
    //     </NavLink>
    //   ),
    //   key: "franchise",
    // },
    // (hasPermission("readAll-games") ||
    //   hasPermission("readSingle-product") ||
    //   hasPermission("create-games")) && {
    //   label: (
    //     <NavLink to='/admin/games'>
    //       <span>All Games</span>
    //     </NavLink>
    //   ),
    //   key: "games",
    // },
    // (hasPermission("readAll-crmTask") ||
    //   hasPermission("readSingle-crmTask") ||
    //   hasPermission("create-crmTask")) && {
    //   label: (
    //     <NavLink to='/admin/slot'>
    //       <span>All Slots</span>
    //     </NavLink>
    //   ),
    //   key: "slot",
    // },
    // (hasPermission("readAll-quote") ||
    //   hasPermission("readSingle-quote") ||
    //   hasPermission("create-quote")) && {
    //   label: (
    //     <NavLink to='/admin/booking'>
    //       <span>All Booking</span>
    //     </NavLink>
    //   ),
    //   key: "booking",
    // },
    // (hasPermission("readAll-opportunity") ||
    //   hasPermission("readSingle-opportunity") ||
    //   hasPermission("create-opportunity")) && {
    //   label: (
    //     <NavLink to='/admin/opportunity'>
    //       <span>Opportunity</span>
    //     </NavLink>
    //   ),
    //   key: "opportunity",
    // },
    // (hasPermission("readAll-quote") ||
    //   hasPermission("readSingle-quote") ||
    //   hasPermission("create-quote") ||
    //   hasPermission("readAll-product") ||
    //   hasPermission("readSingle-product") ||
    //   hasPermission("create-product")) && {
    //   label: (
    //     <span className='flex items-center gap-1'>
    //       Quote <IoIosArrowDown />
    //     </span>
    //   ),
    //   key: "quotes",

    //   children: [
    //     (hasPermission("readAll-quote") ||
    //       hasPermission("readSingle-quote") ||
    //       hasPermission("create-quote")) && {
    //       label: (
    //         <NavLink to='/admin/booking'>
    //           <span>Quote</span>
    //         </NavLink>
    //       ),
    //       key: "quote",
    //     },
    //     (hasPermission("readAll-product") ||
    //       hasPermission("readSingle-product") ||
    //       hasPermission("create-product")) && {
    //       label: (
    //         <NavLink to='/admin/products'>
    //           <span>Products</span>
    //         </NavLink>
    //       ),
    //       key: "products",
    //     },
    //   ],
    // },
    // (hasPermission("readAll-crmTask") ||
    //   hasPermission("readSingle-crmTask") ||
    //   hasPermission("create-crmTask")) && {
    //   label: (
    //     <NavLink to='/admin/slot'>
    //       <span>Task</span>
    //     </NavLink>
    //   ),
    //   key: "task",
    // },
    // (hasPermission("readAll-note") ||
    //   hasPermission("readSingle-note") ||
    //   hasPermission("create-note") ||
    //   hasPermission("readAll-attachment") ||
    //   hasPermission("readSingle-attachment") ||
    //   hasPermission("create-attachment") ||
    //   hasPermission("readAll-email") ||
    //   hasPermission("readSingle-email") ||
    //   hasPermission("create-email")) && {
    //   label: (
    //     <span className='flex items-center gap-1'>
    //       Others <IoIosArrowDown />
    //     </span>
    //   ),
    //   key: "others",

    //   children: [
    //     (hasPermission("readAll-note") ||
    //       hasPermission("readSingle-note") ||
    //       hasPermission("create-note")) && {
    //       label: (
    //         <NavLink to='/admin/note'>
    //           <span>Note</span>
    //         </NavLink>
    //       ),
    //       key: "note",
    //     },
    //     (hasPermission("readAll-attachment") ||
    //       hasPermission("readSingle-attachment") ||
    //       hasPermission("create-attachment")) && {
    //       label: (
    //         <NavLink to='/admin/attachment'>
    //           <span>Attachment</span>
    //         </NavLink>
    //       ),
    //       key: "attachment",
    //     },
    //     (hasPermission("readAll-email") ||
    //       hasPermission("readSingle-email") ||
    //       hasPermission("create-email")) && {
    //       label: (
    //         <NavLink to='/admin/email'>
    //           <span>Email</span>
    //         </NavLink>
    //       ),
    //       key: "email",
    //     },
    //   ],
    // },
    // (getRoleFromToken() === "customer" || getRoleFromToken() === "admin") && {
    //   label: (
    //     <NavLink to='/support/ticket'>
    //       <span>Tickets</span>
    //     </NavLink>
    //   ),
    //   key: "ticket",
    // },
    // (hasPermission("readAll-contactSource") ||
    //   hasPermission("readAll-crmTaskStatus") ||
    //   hasPermission("readAll-opportunitySource")) && {
    //   label: (
    //     <NavLink to='/admin/setup'>
    //       <span>Setup</span>
    //     </NavLink>
    //   ),
    //   key: "setup",
    // },
  ];
  const [collapsed, setCollapsed] = useState(true);
  const sidebarRef = useRef(null);
  const toggleButtonRef = useRef(null);

  const toggleSidebar = () => {
    setCollapsed((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target) &&
        toggleButtonRef.current &&
        !toggleButtonRef.current.contains(event.target) // Ignore clicks on the button
      ) {
        setCollapsed(true);
      }
    };

    if (!collapsed) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [collapsed]);
  const [hasLogin, setHasLogin] = useState(false);
  const isLogged = localStorage.getItem("isLogged");
  useEffect(() => {
      if (window.location.href.includes("login")) {
        setHasLogin(true);
      } else if (window.location.href.includes("register")) {
        setHasLogin(true);
      } else {
        setHasLogin(false);
      }
    }, []);
  if (mobile) {
    return (
      <>
        {/* <Dropdown
          className='md:hidden'
          overlay={<Menu items={menu} mode='inline' />}
          trigger={["click"]}
        >
          <Button type='text' icon={<MenuOutlined />} className='mr-0' />
        </Dropdown> */}
         {isLogged && (      
            <div>
              <Button type='text' icon={<MenuOutlined />} className="lg:hidden bg-[#F5F4F4] text-black"  ref={toggleButtonRef}  onClick={toggleSidebar}/>
            </div>
          )}

        <div  
          ref={sidebarRef}
          className={`fixed top-0 left-0 h-full z-50 transition-all duration-300 ${
            collapsed ? "-translate-x-full" : "translate-x-0"
          }`}
        >
          <SidebarComponent 
            collapsed={collapsed} 
            onNavigate={() => setCollapsed(true)}
          />
        </div>
      </>
    );
  }
  return (
    <div className='hidden md:block'>
      <Menu
        className='bg-transparent text-white border-none font-poppins gap-3'
        mode='horizontal'
        items={menu}
      />
    </div>
  );
};

export default Headnav;
